import menu from '../assets/Menu.png'

export function Navbar(){
    return(
        <nav className="navbar">
            <img className="imgNavbar" alt="Menu" src={menu}/>
        </nav>
    )
} 